import { deprecatedPropValueMessage } from '@cvent/carina-utils';

export const disabledTypeEnum = { STYLE_ONLY: 'style-only' };

const deprecatedAppearanceValuesToUpdatedMap = {
  primary: 'filled',
  secondary: 'lined',
  tertiary: 'ghost'
};

export const mapDeprecatedAppearanceToUpdated = initialAppearance => {
  if (
    Object.keys(deprecatedAppearanceValuesToUpdatedMap).includes(
      initialAppearance
    )
  )
    deprecatedPropValueMessage({
      componentName: 'Button',
      date: 'Q3',
      propName: 'appearance',
      propValue: initialAppearance,
      upgradeURL:
        'https://carina.core.cvent.org/blog/2021/02/23/deprecation-button-appearance-values'
    });

  return (
    deprecatedAppearanceValuesToUpdatedMap[initialAppearance] ||
    initialAppearance
  );
};
